import React from "react";
import { Route, Switch } from "react-router";

import { useParams, useRouteMatch } from "react-router-dom";
import { doc, getFirestore } from "firebase/firestore";
import { useFirestoreDocument } from "@react-query-firebase/firestore";
import { LoadingView } from "../../views/LoadingView";
import { Destination, ErrorView } from "../../views/ErrorView";
import { EditGameView } from "./EditGameViewQuiz";
import { gameConverter } from "../model/Game";
import { EditQuestionView } from "./EditQuestionViewQuiz";

interface RouteParams {
  gameId: string;
}

export const GameView: React.FC = () => {
  //console.log("GameView");
  const { gameId } = useParams<RouteParams>();
  const match = useRouteMatch();

  const ref = doc(getFirestore(), "templates", gameId).withConverter(gameConverter);

  const { isLoading, data, error } = useFirestoreDocument(["templates", gameId], ref, { subscribe: true });

  if (isLoading) {
    return <LoadingView />;
  }
  const game = error ? null : data?.data();

  if (error || !game) {
    return <ErrorView error={error || new Error("Game not found")} destination={Destination.QUIZ} />;
  }

  return (
    <Switch>
      <Route path={`${match.url}/edit-question/:questionId`}>
        <EditQuestionView game={game} />
      </Route>
      <Route path={`${match.url}`} exact={true}>
        <EditGameView game={game} />
      </Route>
    </Switch>
  );
};
